import { IExpenseTagBucketModel } from '@Shared/models';

export const ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS = 'ADD_TEAM_FIELD_EXPENSE_BUCKETS_WITH_TAGS';
export const ADD_ACTIVE_EXPENSE_TAG_BUCKETS = 'ADD_ACTIVE_EXPENSE_TAG_BUCKETS';

// only buckets with "team_field" bucket type (should be not used and removed once we will switch to use paginated API)
export class AddActiveTeamFieldBucketsWithActiveTags {
  readonly type = ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS;
  payload: IExpenseTagBucketModel[];

  constructor(expenseBuckets: IExpenseTagBucketModel[]) {
    this.payload = expenseBuckets;
  }
}

// all expense buckets for organization that are not disabled
export class AddActiveExpenseTagBuckets {
  readonly type = ADD_ACTIVE_EXPENSE_TAG_BUCKETS;
  payload: IExpenseTagBucketModel[];

  constructor(expenseBuckets: IExpenseTagBucketModel[]) {
    this.payload = expenseBuckets;
  }
}

export type ExpenseBucketsAction = AddActiveExpenseTagBuckets | AddActiveTeamFieldBucketsWithActiveTags;
